import { Box, Stack, useMediaQuery, useTheme } from '@mui/material';
import TypographyLevel from 'shared/components/Typography';
import {
    AppFormikTextField,
    AppFormikTextFieldNumber,
} from 'shared/components/AppComponents';
import { useState } from 'react';

/**
 * Component for displaying company details.
 * @returns React element representing the company details.
 */
const CompanyDetails: React.FC<CompanyDetailsProps> = ({
    clientName,
    companyEmail,
    phoneNumber,
}) => {
    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.down('md'));
    const [, setClientName] = useState<string>(clientName);
    const [, setCompanyEmail] = useState<string>(companyEmail);
    const [, setPhone] = useState<number>(phoneNumber);

    return (
        <Box className="solicitor-company-details">
            <TypographyLevel variant="two" className="company-heading">
                Company details
            </TypographyLevel>

            <Stack
                direction={matches ? 'column' : 'row'}
                className="company-details-content"
            >
                <Box className="row-in-details">
                    <TypographyLevel
                        variant="four"
                        className="row-details-heading"
                    >
                        Checklist name
                    </TypographyLevel>
                    <AppFormikTextField
                        name="clientName"
                        placeholder="Type here"
                        onChange={(ev: any) => setClientName(ev.target.value)}
                        // className="styled-action-client"
                    />
                </Box>

                <Box className="row-in-details">
                    <TypographyLevel
                        variant="four"
                        className="row-details-heading"
                    >
                        Company email
                    </TypographyLevel>
                    <AppFormikTextField
                        name="clientEmail"
                        placeholder="Type here"
                        onChange={(ev: any) => setCompanyEmail(ev.target.value)}
                        // className="styled-action-client"
                    />
                </Box>

                <Box className="row-in-details">
                    <TypographyLevel
                        variant="four"
                        className="row-details-heading"
                    >
                        Company phone
                    </TypographyLevel>
                    <AppFormikTextFieldNumber
                        name="contactNumber"
                        placeholder="Type here"
                        onChange={(ev: any) => setPhone(ev.target.value)}
                        // className="styled-action-client"
                    />
                </Box>
            </Stack>
        </Box>
    );
};

export default CompanyDetails;
